import type { Num } from "../types";
import { fmt } from "../lib/format";

/**
 * Позиционная шкала 0–100: где сейчас стоят юрлица («умные деньги») и физлица (толпа)
 * относительно своего диапазона за окно индекса. Зоны 0–20 и 80–100 — экстремумы по Уильямсу.
 */
export function PositionRail({
  smart,
  crowd,
  size = "sm",
  smartLabel = "Юрлица",
  crowdLabel = "Физлица",
}: {
  smart: Num;
  crowd: Num;
  size?: "sm" | "lg";
  smartLabel?: string;
  crowdLabel?: string;
}) {
  const label = `${smartLabel}: ${fmt.idx(smart)}, ${crowdLabel}: ${fmt.idx(crowd)} из 100`;
  return (
    <div className={`rail rail-${size}`} role="img" aria-label={label}>
      <div className="rail-track">
        <span className="rail-zone rail-zone-bear" />
        <span className="rail-zone rail-zone-mid" />
        <span className="rail-zone rail-zone-bull" />
        {crowd != null && (
          <span className={`rail-dot rail-dot-crowd ${edge(crowd)}`} style={{ left: `${clamp(crowd)}%` }}>
            {size === "lg" && <em>{crowdLabel}</em>}
          </span>
        )}
        {smart != null && (
          <span className={`rail-dot rail-dot-smart ${edge(smart)}`} style={{ left: `${clamp(smart)}%` }}>
            {size === "lg" ? <em>{smartLabel}</em> : null}
          </span>
        )}
      </div>
      {size === "lg" && (
        <div className="rail-scale" aria-hidden="true">
          <span>0</span>
          <span style={{ left: "20%" }}>20</span>
          <span style={{ left: "50%" }}>50</span>
          <span style={{ left: "80%" }}>80</span>
          <span style={{ left: "100%" }}>100</span>
        </div>
      )}
    </div>
  );
}

/** У краёв шкалы подпись прижимается внутрь, чтобы не выходить за карточку. */
function edge(v: number) {
  return v < 15 ? "edge-start" : v > 85 ? "edge-end" : "";
}

function clamp(v: number) {
  return Math.max(0, Math.min(100, v));
}
